import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { workloadHeat } from "@/lib/heat";
import api from "@/lib/api";

export const OverloadAlerts = () => {
  const nav = useNavigate();
  const [heavy, setHeavy] = useState([]);

  useEffect(() => {
    api.get("/cards").then(({ data }) => {
      const cards = Array.isArray(data) ? data : data.cards || [];
      setHeavy(cards.filter((c) => (c.open_tasks || 0) >= 8).sort((a, b) => (b.open_tasks || 0) - (a.open_tasks || 0)));
    }).catch((err) => console.debug("overload check failed", err));
  }, []);

  if (!heavy.length) return null;
  return (
    <div className="mb-6 rounded-lg border border-orange-300 bg-orange-50 px-4 py-3" data-testid="overload-alerts">
      <p className="text-sm font-bold text-orange-800 flex items-center gap-2 mb-2">
        <AlertTriangle className="h-4 w-4 shrink-0" />
        {heavy.length === 1 ? "1 resource is" : `${heavy.length} resources are`} carrying a heavy task load across your projects
      </p>
      <div className="flex flex-wrap gap-2">
        {heavy.map((c) => {
          const heat = workloadHeat(c.open_tasks || 0);
          return (
            <button key={c.key} type="button" onClick={() => nav("/cards")}
              title={`Open ${c.person}'s resource card`}
              className="inline-flex items-center gap-2 rounded-full bg-white border border-orange-200 px-3 py-1 text-xs font-semibold hover:border-orange-400 transition-colors"
              data-testid={`overload-chip-${c.key.replace(/\s/g, "-")}`}>
              {c.person}
              <span className="font-bold" style={{ color: heat.bg }}>{c.open_tasks} open · {heat.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default OverloadAlerts;
